import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';
import { AchievementService } from '../../services/achievement.service';
import { AuthService } from '../../services/auth.service';
import { UIStateService } from '../../services/ui-state.service';
import { View } from '../base.component';


@Component({
    selector: 'app-achievement-badge',
    templateUrl: './achievement-badge.component.html',
    styleUrls: ['./achievement-badge.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AchievementBadgeComponent extends View {
    public static route = 'pet';

    achievementType = input<number>();

    achievementResource = rxResource({
        params: () => this.achievementType(),
        stream: ({ params }) => params ? this.achievementService.getAchievementConfig(params) : of(undefined)
    });

    constructor(private achievementService: AchievementService, authService: AuthService, uiStateService: UIStateService) {
        super(authService, uiStateService);
    }
}
